module.exports = __webpack_public_path__ + "img/94854.c44c7883.svg";